import React, { useState, useEffect, useContext } from 'react'
import { SubOrden } from './SubOrden'
import { Button, Checkbox, Label, LabelDetail, Container, Form, Message } from 'semantic-ui-react'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import AlmDropdown from '../../../componentes/AlmDropdown'
import { AuthContext } from '../../../Auth'

export const NuevaOrdenCompra = ({ onSave }) => {
    const { currentUser } = useContext(AuthContext)
    const [subOrders, setSubOrders] = useState([])
    const [options, setOptions] = useState([])
    const [urgente, setUrgente] = useState(false)
    const [color, setColor] = useState([])
    const [almacen, setAlmacen] = useState('')
    const [message, setMessage] = useState('')

    useEffect(() => {
        fetchProducts()
    }, [])
    const fetchProducts = async () => {
        const tempOptions = []
        const products = (await firebase.firestore().collection('Herramientas').orderBy('nombre', 'asc').get()).docs
        for (let i in products) {
            tempOptions.push({
                key: i,
                value: i,
                text: products[i].data().nombre,
            })
        }
        setOptions(tempOptions)
    }
    const AddSubOrder = () => {
        const tempSubOrders = [...subOrders]
        tempSubOrders.push({
            product: '',
            quantity: 0,
            units: '',
            status: 'solicitado',
        })
        setSubOrders(tempSubOrders)
    }
    const handleChange = (index, subOrder) => {
        const tempSubOrders = [...subOrders]
        tempSubOrders[index] = subOrder
        setSubOrders(tempSubOrders)
    }
    const validateSubmit = () => {
        if (!almacen) {
            setMessage("Seleccione el almacén")
            return false
        }
        if (subOrders.length < 1 ) {
            setMessage("Seleccione el producto.")
            return false
        }
        for (let i in subOrders) {
            if (subOrders[i].quantity <= 0 || subOrders[i].product === '') {
                return false
            }
        }
        setMessage('')
        return true
    }
    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!validateSubmit())
            return null
        await firebase.firestore().collection('OrdenCompra').add({
            requestedBy: currentUser.name,
            requestedTo: almacen,
            products: subOrders,
            status: 'pendingApproval',
            pendientes: subOrders.length,
            urgente: urgente,
            tipo: "herramienta",
            fechaCreado: new Date(),
        })
        onSave()
    }
    const urgenteCheckbox =(e,{checked})=>{
        setUrgente(checked)
        if (checked === true){
            setColor("orangered")
        } else{
            setColor()
        }
    }
    const handleAlmacenChange = (event, { value }) => {
		setAlmacen(value)
	};
    return (
        <Form onSubmit={handleSubmit} style={{backgroundColor: color}}>
            <Container textAlign='right'>
                <Checkbox 
                    toggle label='Es URGENTE?' 
                    onChange={urgenteCheckbox}
                />
            </Container>
            <Container>
                <Label horizontal>
                    Enviar a:
                    <LabelDetail>
                        <AlmDropdown 
                            placeholder='almacén'
                            value={almacen} 
                            onChange={handleAlmacenChange} 
                            all={1} 
                        />
                    </LabelDetail>
                </Label>
            </Container>
            <Container textAlign='center'>
                <Button 
                    icon='add' 
                    onClick={AddSubOrder}
                    content='Producto'
                />
            </Container>
            {subOrders.map((subOrder, i) => {
                return (
                    <SubOrden
                        key ={i}
                        index={i}
                        options={options}
                        handleChange={handleChange}
                    />
                )
            })}
            {message?<Message>{message}</Message>:null}
            <Button type='submit'>Crear</Button>
        </Form>
    )
}